import KickImage from 'Reuseables/KickImage';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { getAllBrands } from '../../actions/filterAction';
import { toTitleCase } from '../../helpers/textConverter';
import { getQueryParamsUrl } from "../../helpers/url";
import CloseFilter from '../../images/close_icon.png';
import { colorSearchPage, genderSearchPage, sneakersConditionText } from '../../utils/Helpers';

class SelectedFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {}
  }

  filterCondition = (key, value) => {
    const { history, brandList, dataAuth } = this.props;
    const params = getQueryParamsUrl(history.location.search);
    let currency = 'IDR'
    const userCurrency = dataAuth.isLogged && dataAuth.userCurrency
    if (userCurrency) {
      currency = userCurrency.currency || 'IDR'
    }

    if (key === "brands") {
      const selectedBrand = brandList.find(brand => brand.id == value);
      return `${selectedBrand && selectedBrand.name ? selectedBrand.name : ''}`
    } else if (key === "sneakers_condition") {
      return sneakersConditionText(value)
    } else if (key === "sex") {
      return genderSearchPage(value)
    } else if (key === "color") {
      return colorSearchPage(value)
    } else if (key === "startPrice" || key === "endPrice") {
      if (key === "startPrice" && params.endPrice) {
        return `${currency} ${value} - ${params.endPrice}`
      } else if (key === "startPrice") {
        return `${currency} ${value}  - Highest`
      } else {
        return `${currency} 0 - ${value}`
      }
    } else if (key === "sizeTypes") {
      switch (value) {
        case "M":
          return `US Men ${params.sizes}`
        case "F":
          return `US Women ${params.sizes}`
        case "Y":
          return `US Youth ${params.sizes}`
      }
    } else {
      return null
    }
  }

  sizeCondition = (type, us, alias = '') => {
    switch (type) {
      case "M":
        return `US Men ${us}`
      case "F":
        return `US Women ${us}`
      case "Y":
      case "IT":
        return `US Youth ${us}`
      case "U":
        return `US ${alias ? toTitleCase(alias) : 'Top'} ${us}`
    }
  }

  categoryCondition = (category) => {
    switch (category) {
      case "madeindonesia":
        return "MadeIndonesia"
      case `${category}`:
        return `${category}`
    }
  }

  selectedSize = () => {
    const sizeId = this.props.data.length > 0 && this.props.data.find((item) => (item.value !== undefined) && (item.key === "sizeId"))
    const sizeTypes = this.props.data.length > 0 && this.props.data.find((item) => (item.value !== undefined) && (item.key === "sizeTypes"))
    const sizes = this.props.data.length > 0 && this.props.data.find((item) => (item.value !== undefined) && (item.key === "sizes"))
    const sizeAlias = this.props.data.length > 0 && this.props.data.find((item) => (item.value !== undefined) && (item.key === "sizeAlias"))

    const arrSizeId = sizeId?.value?.split(',')
    const arrSizeTypes = sizeTypes?.value?.split(',')
    const arrSizes = sizes?.value?.split(',')
    const arrSizeAlias = sizeAlias?.value?.split(',')

    const mergeSize = arrSizeId?.map((x, i) => {
      if (arrSizeAlias) {
        return [x, arrSizeTypes[i], arrSizes[i], arrSizeAlias[i]]
      }
      return [x, arrSizeTypes[i], arrSizes[i], '']
    })

    const selectedSize = []

    for (const r of mergeSize) {
      selectedSize.push({
        id: r[0],
        sex: r[1],
        US: r[2],
        alias: r[3],
      })
    }

    return selectedSize
  }

  render() {
    const { history, brands, dataFilter, data, searchKeyword } = this.props;
    let dataFiltered = data.length > 0 && data.filter((item) => (item.value !== undefined) && (item.key !== "sizeId") && (item.key !== "sizeTypes") && (item.key !== "sizes") && (item.key !== "sizeAlias"))
    let priceKeys = 0
    if (dataFiltered.length > 0) {
      dataFiltered.map(item => {
        if (item.key === 'startPrice' || item.key === 'endPrice') priceKeys++
      })
      if (priceKeys === 2) {
        dataFiltered = dataFiltered.filter(item => item.key !== 'endPrice' && item.key)
      }
    }

    const sizeId = data.length > 0 && data.find((item) => (item.value !== undefined) && (item.key === "sizeId"))
    const sizeTypes = data.length > 0 && data.find((item) => (item.value !== undefined) && (item.key === "sizeTypes"))
    const sizes = data.length > 0 && data.find((item) => (item.value !== undefined) && (item.key === "sizes"))

    const { slug } = this.props.match.params;
    const label = slug && slug.replace(/[^A-Z0-9]+/ig, " ");

    const { path } = this.props.match;
    const name = path.slice(11).replace(/[^A-Z0-9]+/ig, " ");

    return (
      <>

        {
          this.props.selectedCategory &&
          <div className="selected-button" onClick={() => this.props.removeFilter("searchCategory")}>
            <p>{this.categoryCondition(this.props.selectedCategory)} <KickImage className="close__icon" src={CloseFilter} alt="" /></p>
          </div>
        }

        {
          dataFiltered.map((data, index) => {
            return (
              <div className="selected-button" onClick={() => this.props.removeFilter(data.key === 'brands' ? data : `${data.key}`)}>
                <p>
                  {this.filterCondition(data.key, data.value)} <KickImage className="close__icon" src={CloseFilter} alt="" />
                </p>
              </div>
            )
          })
        }

        {
          ((this.props.searchKeyword === "") && (this.props.selectedCategory === undefined) && (dataFiltered.length === 0)) ? null :
            <div style={{ cursor: "pointer", height: "43px", padding: "12px 12px 12px 0" }} onClick={() => this.props.resetFilter()}>
              <p style={{ marginBottom: 0 }}>Reset</p>
            </div>
        }

      </>
    )
  }
}


const mapStateToProps = state => ({
  dataAuth: state.dataAuth,
  dataFilter: state.filterReducer
});

const mapDispatchToProps = dispatch => {
  return {
    getAllBrands: (query) => dispatch(getAllBrands(query))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectedFilter));